import { Column, SemanticModel } from "@pufflig/prompt-studio-types";
import { useSemanticModelStore } from "../SemanticModelProvider";

export const toggleVisibility = async (id: string) => {
  useSemanticModelStore.setState(
    (state) => {
      const { semanticModel, dbSchema } = state;

      if (!dbSchema) return;

      let newSemanticModel: SemanticModel = semanticModel || {
        name: dbSchema.name,
        description: dbSchema.description,
        schemas: {},
        connectors: dbSchema.connectors || [],
      };

      const parts = id.split("-");

      const [schemaName, tableName] = parts;
      const isVisible = tableName
        ? !newSemanticModel.schemas[schemaName]?.tables?.[tableName].hidden
        : !newSemanticModel.schemas[schemaName].hidden;

      // if the schema is not available in the semantic model, add it from the db query schema
      if (!newSemanticModel.schemas[schemaName]) {
        newSemanticModel.schemas[schemaName] = {
          ...dbSchema.schemas[schemaName],
        };
      }

      // if the table is not available in the semantic model, add it from the db query schema
      if (tableName && !newSemanticModel.schemas[schemaName]?.tables?.[tableName]) {
        newSemanticModel.schemas[schemaName].tables = {
          ...(newSemanticModel.schemas[schemaName]?.tables || {}),
          [tableName]: {
            ...dbSchema.schemas[schemaName]?.tables?.[tableName],
          },
        };
      }

      if (isVisible) {
        // when selecting the schema, hide it if it is visible
        if (!tableName) {
          newSemanticModel.schemas[schemaName].hidden = true;
          // hide all tables columns when schema hidden
          Object.values(newSemanticModel.schemas[schemaName].tables).forEach((t) => {
            t.columns = [];
            t.hidden = true;
          });
        }

        if (tableName) {
          newSemanticModel.schemas[schemaName].tables[tableName] = {
            ...newSemanticModel.schemas[schemaName].tables[tableName],
            hidden: true,
            columns: [],
          };
        }
      }

      if (!isVisible) {
        if (!tableName) {
          newSemanticModel.schemas[schemaName].hidden = false;
          // show all tables and their columns when schema is toggled on
          Object.entries(newSemanticModel.schemas[schemaName].tables).forEach(([tblName, tbl]) => {
            tbl.hidden = false;
            tbl.columns = dbSchema.schemas[schemaName].tables[tblName].columns;
          });
        }

        if (tableName) {
          const table = newSemanticModel.schemas[schemaName].tables[tableName];
          table.hidden = false;
          // when table is toggled on, show all columns
          table.columns = dbSchema.schemas[schemaName].tables[tableName].columns;
        }
      }

      state.semanticModel = newSemanticModel;

      if (state.selectedTable) {
        const [selSchema, selTable] = state.selectedTable.split(".");
        if (selSchema === schemaName && tableName && selTable === tableName) {
          const connectorColumns = dbSchema.schemas[schemaName].tables[tableName].columns;
          const tableColumns = newSemanticModel.schemas[schemaName].tables[tableName].columns;
          const merged: Column[] = connectorColumns.map((c) => {
            const m = tableColumns.find((mc) => mc.columnName === c.columnName);
            return { ...c, ...(m || {}), hidden: !m } as Column;
          });
          state.selectedTableSchema = merged;
        }
        if (!tableName && selSchema === schemaName) {
          // schema hidden/unhidden affects selected table
          const [_, selTableName] = state.selectedTable.split(".");
          const connectorColumns = dbSchema.schemas[selSchema].tables[selTableName].columns;
          const tableColumns = newSemanticModel.schemas[selSchema].tables[selTableName].columns;
          const merged: Column[] = connectorColumns.map((c) => {
            const m = tableColumns.find((mc) => mc.columnName === c.columnName);
            return { ...c, ...(m || {}), hidden: !m } as Column;
          });
          state.selectedTableSchema = merged;
        }
      }
    },
    false,
    "semantic/toggle_visibility",
  );
};
